import { render, staticRenderFns } from "./DataBlockChain.vue?vue&type=template&id=c145d7da&scoped=true&"
import script from "./DataBlockChain.vue?vue&type=script&lang=js&"
export * from "./DataBlockChain.vue?vue&type=script&lang=js&"
import style0 from "./DataBlockChain.vue?vue&type=style&index=0&id=c145d7da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c145d7da",
  null
  
)

export default component.exports